<template>
  <div class="treasury-payment-gateways-list fixed-draggable-dynamic-table-wrapper-height">
    <draggable-dynamic-table ref="paymentGatewaysList"
                             :data="data"
                             :columns="columnsLabel"
                             :options="options"
                             @filter:remove="setFilter($event, true)"
                             @filter:set="setFilter($event)"
                             @sort:set="setSort($event)"
                             @row:clicked="selectedPaymentGateway = $event, showPaymentGatewayProfilePromptStatus = true"
                             @load:more="getPaymentGateways()"/>

    <!--  show payment gateway details prompt  -->
    <vs-prompt
      class="medium-prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="showPaymentGatewayProfilePromptStatus"
      @close="showPaymentGatewayProfilePromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div v-if="checkUserPermissions('payment_gateway.update')" @click="editPaymentGatewayPromptStatus = true">
              <custom-icon color="warning"
                           icon="EDIT"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="prompt-title w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.paymentGateways.paymentGateway.dynamicTitle', {paymentGateway: selectedPaymentGateway.title}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="showPaymentGatewayProfilePromptStatus = false">
              <custom-icon color="danger"
                           icon="TIMES-CIRCLE"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content py-2 px-3">
        <template>
          <keep-alive>
            <payment-gateway :payment-gateway-id="selectedPaymentGateway.id"/>
          </keep-alive>
        </template>
      </div>
    </vs-prompt>

    <!--  edit payment gateway prompt  -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="editPaymentGatewayPromptStatus"
      @close="editPaymentGatewayPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('editPaymentGatewaysBTN')">
              <custom-icon color="success"
                           icon="SAVE"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="prompt-title w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.paymentGateways.edit.dynamicTitle', {paymentGateway: selectedPaymentGateway.title}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="editPaymentGatewayPromptStatus = false">
              <custom-icon color="danger"
                           icon="TIMES-CIRCLE"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content py-2 px-3">
        <template>
          <keep-alive>
            <edit-payment-gateway :payment-gateway-id="selectedPaymentGateway.id"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <!--  insert payment gateway prompt  -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="insertPaymentGatewayPromptStatus"
      @close="insertPaymentGatewayPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('insertPaymentGatewaysBTN')">
              <custom-icon color="success"
                           icon="SAVE"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="prompt-title w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.paymentGateways.insert.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="insertPaymentGatewayPromptStatus = false">
              <custom-icon color="danger"
                           icon="TIMES-CIRCLE"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content py-2 px-3">
        <template>
          <keep-alive>
            <insert-payment-gateway/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <button v-show="false"
            id="insertPaymentGateway"
            @click="insertPaymentGatewayPromptStatus = true"/>
  </div>
</template>

<script>
import {getPaymentGateways, getPaymentGatewaysPrice} from '../../../../../http/requests/paymentGateways'
import {getBanks} from '../../../../../http/requests/banks'
import CustomIcon from '../../../../../components/customIcon/customIcon'
import PaymentGateway from '../paymentGateway/profile/paymentGateway'
import EditPaymentGateway from '../paymentGateway/edit/editPaymentGateway'
import InsertPaymentGateway from '../insert/insertPaymentGateway'
import {addComma, checkUserPermissions} from "../../../../../assets/js/functions";

export default {
  name: 'paymentGateways',
  components: {InsertPaymentGateway, EditPaymentGateway, PaymentGateway, CustomIcon},
  metaInfo () {
    return {
      title: this.$t('treasury.paymentGateways.list.title')
    }
  },
  data () {
    return {
      showPaymentGatewayProfilePromptStatus: false,
      editPaymentGatewayPromptStatus: false,
      insertPaymentGatewayPromptStatus: false,
      requestSent: false,
      priceRequestSent: false,
      loadingTimer: 0,
      options: {
        id: 'paymentGatewaysList',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'balance',
          i18n: 'treasury.paymentGateways.table.header.balance',
          width: 'calc(100% / 4)',
          minWidth: 100,
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'equals',
              name: 'برابر باشد',
              i18n: 'draggableTable.filter.types.equals',
              id: 1
            },
            {
              icon: 'not-equal',
              name: 'برابر نباشد',
              i18n: 'draggableTable.filter.types.notEqual',
              id: 2
            },
            {
              icon: 'greater-than-equal',
              name: 'بزرگتر مساوی',
              i18n:
                'draggableTable.filter.types.greaterThanEquals',
              id: 4
            },
            {
              icon: 'less-than-equal',
              name: 'کوچکتر مساوی',
              i18n: 'draggableTable.filter.types.lessThanEquals',
              id: 3
            }
          ],
          footer: {}
        },
        // {
        //   field: 'bank',
        //   i18n: 'treasury.paymentGateways.table.header.bank',
        //   width: 'calc(100% / 4)',
        //   minWidth: 150,
        //   filter: true,
        //   filterType: 'checkbox',
        //   filterTypes: [],
        //   align: 'center',
        //   sortable: true
        // },
        {
          field: 'status',
          i18n: 'treasury.paymentGateways.table.header.status',
          width: 'calc(100% / 4)',
          minWidth: 80,
          filter: true,
          filterType: 'select',
          filterTypes: [
            {
              label: this.$t('treasury.paymentGateways.status.all'),
              value: '-1'
            },
            {
              label: this.$t('treasury.paymentGateways.status.enable'),
              value: '1'
            },
            {
              label: this.$t('treasury.paymentGateways.status.disable'),
              value: '0'
            }
          ],
          align: 'center',
          sortable: true
        },
        {
          field: 'title',
          i18n: 'treasury.paymentGateways.table.header.title',
          width: 'calc(100% / 4)',
          minWidth: 170,
          filter: true,
          filterTypes: [
            {
              icon: 'search',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ],
          align: 'center',
          sortable: true
        },
        {
          field: 'type',
          i18n: 'treasury.paymentGateways.table.header.type',
          width: 'calc(100% / 4)',
          minWidth: 100,
          align: 'center',
          filter: true,
          filterType: 'select',
          filterTypes: [
            {
              label: this.$t('treasury.paymentGateways.types.all'),
              value: '-1'
            },
            {
              label: this.$t('treasury.paymentGateways.types.online'),
              value: '1'
            },
            {
              label: this.$t('treasury.paymentGateways.types.pos'),
              value: '2'
            }
          ],
          sortable: true,
          locked: true
        },
        {
          field: 'rowNumber',
          i18n: 'treasury.paymentGateways.table.header.row',
          width: '60px',
          minWidth: 60,
          align: 'center',
          // sortable: true,
          locked: true,
          footer: {}
        }
      ],
      data: [],
      selectedPaymentGateway: {},
      filters: [],
      sorts: [],
      page: 1,
      endedList: false,
      actions: [
        {
          toolbar: [
            {
              id: 'insertPaymentGateway',
              icon: 'icon-plus',
              iconPack: 'feather',
              color: 'success',
              permission: 'payment_gateway.create'
            }
          ],
          leftToolbar: [
            {
              id: 'printTable',
              // i18n: 'draggableDynamicTable.actions.print',
              icon: 'icon-printer',
              iconPack: 'feather'
            },
            {
              id: 'downloadTable',
              // i18n: 'draggableDynamicTable.actions.download',
              icon: 'icon-download',
              iconPack: 'feather'
            },
            {
              id: {name: 'trashedPaymentGateways'},
              type: 'link',
              icon: 'icon-trash',
              iconPack: 'feather',
              permission: 'payment_gateway.delete'
            },
            {
              id: 'settingTable',
              icon: 'icon-settings',
              iconPack: 'feather'
            }
          ]
        }
      ]
    }
  },
  created () {
    setTimeout(() => {
      this.$store.dispatch('updateNavbarActions', this.actions[0])
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    }, 50)

    this.getPaymentGateways()
    // this.getBanks()
  },
  methods: {
    checkUserPermissions(permission) {
      return checkUserPermissions(permission)
    },
    getPaymentGateways () {
      if (!this.requestSent) {
        this.requestSent = true

        clearTimeout(this.loadingTimer)
        this.loadingTimer = setTimeout(() => {
          if (!this.endedList) {
            if (this.$refs.paymentGatewaysList && this.data.length === 0) this.$refs.paymentGatewaysList.loadMoreStatus = 'FirstLoad'
            else if (this.$refs.paymentGatewaysList && this.data.length > 0) this.$refs.paymentGatewaysList.loadMoreStatus = 'Loading'

            getPaymentGateways(this.page, this.filters, this.sorts).then(response => {
              this.endedList = response.data.data.length === 0
              const paymentGateways = response.data.data

              paymentGateways.forEach((paymentGateway) => {
                this.data.push({
                  /*route: {
                    name: 'paymentGateway',
                    params: {id: paymentGateway.id}
                  },*/
                  id: paymentGateway.id,
                  rowNumber: this.data.length + 1,
                  title: paymentGateway.title,
                  // bank: paymentGateway.bank ? paymentGateway.bank.name : '-',
                  type: paymentGateway.type === 1 ? this.$t('treasury.paymentGateways.types.online') : this.$t('treasury.paymentGateways.types.pos'),
                  status: paymentGateway.enabled ? {value: this.$t('treasury.paymentGateways.status.enable'), classes: 'text-success'} : {value: this.$t('treasury.paymentGateways.status.disable'), classes: 'text-danger'},
                  balance: {
                    type: 'price',
                    classes: paymentGateway.balance && paymentGateway.balance < 0 ? 'text-danger' : 'text-success',
                    value: paymentGateway.balance ? paymentGateway.balance : 0
                  }
                })
              })

              this.page = response.data.pagination.current_page + 1
              if (response.data.pagination.current_page === 1) {
                const row_index = this.columnsLabel.map((e) => {
                  return e.field
                }).indexOf('rowNumber')
                this.columnsLabel[row_index].footer.value = response.data.pagination.total
              }

              if (this.$refs.paymentGatewaysList) this.$refs.paymentGatewaysList.loadMoreStatus = ''

              this.requestSent = false
            }).catch(() => {

              if (this.$refs.paymentGatewaysList) this.$refs.paymentGatewaysList.loadMoreStatus = 'Danger'

              this.requestSent = false
            })
          } else {
            this.requestSent = false
          }
        }, 400)
      }
    },
    getPaymentGatewaysPrice () {
      if (!this.priceRequestSent) {
        this.priceRequestSent = true
        getPaymentGatewaysPrice(this.filters).then(response => {
          this.priceRequestSent = false
          const price_index = this.columnsLabel.map((e) => {
            return e.field
          }).indexOf('balance')
          this.columnsLabel[price_index].footer = {
            value: addComma(response.data.data.total)
          }
        })
          .catch(() => {
            this.priceRequestSent = false
          })
      }
    },
    getBanks () {
      getBanks().then(response => {
        const banks = []
        response.data.data.forEach((bank) => {
          banks.push({
            id: bank.id,
            label: bank.name,
            value: bank.id,
            show: false
          })
        })

        this.columnsLabel[this.columnsLabel.map(elm => {
          return elm.field
        }).indexOf('bank')].filterTypes = banks
      })
    },
    setFilter (filters) {
      if (!this.getFiltersStatus) {
        let filters_list = []
        const attributes = []
        Object.keys(filters).forEach((key) => {
          switch (key) {

          case 'bank':
            if (filters[key].search.length) {
              const banks_id = filters[key].search.map(elm => {
                return elm.show ? elm.id : null
              }).filter(elm => {
                return elm !== null
              }).join('_')

              if (banks_id !== '') filters_list.push(`bank=${banks_id}`)
            }
            break

          case 'balance':
            if (filters[key].search !== '') filters_list.push(`balance=${filters[key].search}${filters[key].type.id > 0 ? (`,${filters[key].type.id}`) : ''}`)
            break

          case 'title':
            if (filters[key].search !== '') filters_list.push(`title=${filters[key].search}${filters[key].type.id > 0 ? (`,${filters[key].type.id}`) : ''}`)
            break

          case 'type':
            if (filters[key].search.value > -1) filters_list.push(`type=${filters[key].search.value}`)
            break

          case 'status':
            if (filters[key].search.value >= 0) filters_list.push(`enabled=${filters[key].search.value}`)
            break
          }
        })
        filters_list = [filters_list, ...attributes]

        this.data = []
        this.page = 1
        this.endedList = false
        this.filters = filters_list
        this.getPaymentGateways()
        this.getPaymentGatewaysPrice()
      }
    },
    setSort (sorts) {
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

        case 'rowNumber':
          sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'bank':
          sorts_list.push(`order[0]=bank_id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'balance':
          sorts_list.push(`order[0]=balance,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'title':
          sorts_list.push(`order[0]=title,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'type':
          sorts_list.push(`order[0]=type,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'status':
          sorts_list.push(`order[0]=enabled,${  sorts[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (sorts_list.length === 0) {
        this.sorts.push('order[0]=updated_at,desc')
      }

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.getPaymentGateways()
    },
    handleClick (id) {
      document.getElementById(id).click()
    }
  },
  watch: {
    '$store.state.helper.paymentGatewaysChanged': {
      handler (val) {
        if (val) {
          this.showPaymentGatewayProfilePromptStatus = false
          this.editPaymentGatewayPromptStatus = false
          this.insertPaymentGatewayPromptStatus = false

          this.data = []
          this.page = 1
          this.endedList = false
          this.getPaymentGateways()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
